import React from 'react';
import { useTranslation } from 'react-i18next';
import { weeksAndDays } from '../../services/time';

export const WeeksAndDaysDuration = ({ days: ds }: { days: number }) => {
  const { t } = useTranslation();
  const { weeks, days } = weeksAndDays(ds);
  const els: string[] = [];
  if (weeks) {
    els.push(t('weekWithCount', { count: weeks }));
  }
  if (!weeks || days) {
    els.push(t('dayWithCount', { count: days }));
  }
  return <span>{els.join(', ')}</span>;
};
